{
  "version": 1,
  "asset_id": "2f4b2d95-0570-4d2f-a089-0cd7fe062d4e",
  "project_id": "42f7b672-abb9-48a4-a474-c45868224dff",
  "url": "/img.jpeg",
  "original_filename": "img.jpeg",
  "content_type": "image/jpeg",
  "alt": "Share The Med Header"
}
